var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.61,
    height: 30.316,
    viewBox: "0 0 30.61 30.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#272d3b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.964,28.579H23.351a4.083,4.083,0,0,1-4.24-3.892V5.63a4.083,4.083,0,0,1,4.24-3.892H32.1a.906.906,0,0,0,.946-.869A.906.906,0,0,0,32.1,0H23.351a5.9,5.9,0,0,0-6.132,5.63V24.687a5.9,5.9,0,0,0,6.132,5.63h8.613a.872.872,0,1,0,0-1.737Z",
    transform: "translate(-17.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M143.611,142.1l-6.013-5.52a1,1,0,0,0-1.339,0,.817.817,0,0,0,0,1.229l4.4,4.04h-19.2a.872.872,0,1,0,0,1.737h19.2l-4.4,4.04a.817.817,0,0,0,0,1.229,1,1,0,0,0,.666.257.966.966,0,0,0,.666-.257l6.013-5.52A.819.819,0,0,0,143.611,142.1Z",
    transform: "translate(-113.279 -127.554)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.afa82dc83337ed2ca0c9ea0a7e39a41d.svg";
export { ForwardRef as ReactComponent };